import React from 'react';
import {
  BHOM_TEMPLATE,
  expandIfJustTenantNumber,
  ITSM_TEMPLATE,
  normalizeTenantUrlBlur,
  selectTenantSegment,
} from '../Utils/tenantUrlTemplate';

export { BHOM_TEMPLATE, ITSM_TEMPLATE };

const TenantUrlInput = ({
  value,
  onChange,
  template = BHOM_TEMPLATE,
  className = '',
  onBlurAfter,
  ...rest
}) => {
  const handleFocus = (event) => {
    if (!String(value || '').trim()) {
      onChange(template);
      requestAnimationFrame(() => selectTenantSegment(event.target, template));
    } else {
      selectTenantSegment(event.target, value);
    }
  };

  const handleChange = (event) => {
    onChange(expandIfJustTenantNumber(event.target.value, template));
  };

  const handleBlur = (event) => {
    const nextValue = normalizeTenantUrlBlur(event.target.value, template);
    if (nextValue !== value) {
      onChange(nextValue);
    }
    if (onBlurAfter) {
      onBlurAfter(nextValue);
    }
  };

  return (
    <input
      className={className}
      value={value || ''}
      placeholder={template}
      onFocus={handleFocus}
      onChange={handleChange}
      onBlur={handleBlur}
      {...rest}
    />
  );
};

export default TenantUrlInput;
